/* MERA MERAH - AT-only Blocker + Wishlist-CTA. v3 - fixes drawer checkout link + broader anchor selectors. */
(function(){
  var LANG=(document.documentElement.lang||'').toLowerCase().split('-')[0];
  var DE=LANG==='de';
  function detectCountry(){
    try{if(window.Shopify&&Shopify.country){return String(Shopify.country).toUpperCase();}}catch(e){}
    var nl=(navigator.language||'').toUpperCase();
    var m=nl.split('-');
    if(m.length>1)return m[1];
    if(m[0]==='DE')return 'DE';
    return null;
  }
  function isAT(){var c=detectCountry();return c==='AT';}
  var T={de:{title:'Versand nur nach Österreich',body:'Aus rechtlichen Gründen (EU-Verpackungsverordnung) können wir aktuell ausschließlich innerhalb Österreichs versenden. Sobald wir wieder EU-weit ausliefern, informieren wir dich – füge dieses Produkt zu deiner Wunschliste hinzu und du wirst automatisch benachrichtigt.',wish:'Zur Wunschliste hinzufügen',close:'Schließen',view:'Meine Wunschliste'},en:{title:'Shipping to Austria only',body:'Due to EU packaging regulations, we currently ship exclusively within Austria. As soon as we resume EU-wide shipping, we will let you know. Add this product to your wishlist and you will be notified automatically.',wish:'Add to Wishlist',close:'Close',view:'My Wishlist'}};
  function tr(){return DE?T.de:T.en;}
  function markBody(){var c=isAT()?'mm-is-at':'mm-non-at';document.documentElement.classList.add(c);document.body&&document.body.classList.add(c);}
  markBody();
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',markBody);}
  function ensureModal(){
    if(document.getElementById('mm-atonly-modal'))return document.getElementById('mm-atonly-modal');
    var t=tr();
    var wrap=document.createElement('div');
    wrap.id='mm-atonly-modal';wrap.className='mm-atonly-modal';
    wrap.setAttribute('role','dialog');wrap.setAttribute('aria-modal','true');
    wrap.innerHTML='<div class="mm-atonly-backdrop"></div><div class="mm-atonly-panel" role="document"><button type="button" class="mm-atonly-x" aria-label="'+t.close+'">×</button><div class="mm-atonly-flag">🇦🇹</div><h2 class="mm-atonly-title">'+t.title+'</h2><p class="mm-atonly-body">'+t.body+'</p><div class="mm-atonly-actions"><button type="button" class="mm-atonly-btn mm-atonly-btn--primary mm-atonly-wish">'+t.wish+'</button><button type="button" class="mm-atonly-btn mm-atonly-btn--ghost mm-atonly-view">'+t.view+'</button></div><button type="button" class="mm-atonly-btn-close">'+t.close+'</button></div>';
    document.body.appendChild(wrap);
    function close(){wrap.classList.remove('mm-atonly-open');document.body.classList.remove('mm-atonly-lock');}
    wrap.querySelector('.mm-atonly-x').addEventListener('click',close);
    wrap.querySelector('.mm-atonly-btn-close').addEventListener('click',close);
    wrap.querySelector('.mm-atonly-backdrop').addEventListener('click',close);
    wrap.querySelector('.mm-atonly-wish').addEventListener('click',function(){
      try{
        var addBtn=document.querySelector('.swym-add-to-wishlist, .swym-button.swym-add-to-wishlist');
        if(addBtn){addBtn.click();setTimeout(close,300);}else{window.location.href='/apps/swym-wishlist';}
      }catch(e){window.location.href='/apps/swym-wishlist';}
    });
    wrap.querySelector('.mm-atonly-view').addEventListener('click',function(){
      var vb=document.querySelector('.swym-wishlist-button, .swym-view-wishlist, [data-swym-view-wishlist]');
      if(vb){vb.click();close();}else{window.location.href='/apps/swym-wishlist';}
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&wrap.classList.contains('mm-atonly-open'))close();});
    return wrap;
  }
  function openModal(){var m=ensureModal();m.classList.add('mm-atonly-open');document.body.classList.add('mm-atonly-lock');}
  function shouldBlock(){return !isAT();}
  function isAddToCartBtn(el){if(!el||!el.matches)return false;
    var sel='[name="add"], button[type="submit"].product-form__submit, .product-form__submit, .add-to-cart, .add-to-cart-btn, [data-add-to-cart]';
    return el.matches(sel)||el.closest(sel);}
  function isCheckoutEl(el){
    if(!el||!el.matches)return false;
    var sel='[name="checkout"], .cart__checkout, .cart-checkout, .checkout-button, [data-checkout], .shopify-payment-button__button, .shopify-payment-button button, .mm-buynow, a[href="/checkout"], a[href="/checkouts"], a[href^="/checkout?"], a[href*="/checkouts/"], a.btn--wide[href*="checkout"], .cart-drawer a[href*="checkout"], .section-cart-drawer a[href*="checkout"]';
    if(el.matches(sel)||el.closest(sel))return true;
    var link=el.tagName==='A'?el:el.closest('a');
    if(link){var h=link.getAttribute('href')||'';if(h==='/checkout'||h==='/checkouts'||/^\/checkout(s)?(\/|\?|$)/.test(h))return true;}
    return false;
  }
  document.addEventListener('click',function(e){
    if(!shouldBlock())return;
    if(isAddToCartBtn(e.target)||isCheckoutEl(e.target)){
      e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();openModal();
    }
  },true);
  document.addEventListener('submit',function(e){
    if(!shouldBlock())return;
    var f=e.target;
    if(f&&f.matches&&(f.matches('form[action*="/cart/add"]')||f.matches('form[action*="/checkout"]')||f.matches('form.product-form'))){
      e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();openModal();
    }
  },true);
  if(document.readyState!=='loading'){ensureModal();}else{document.addEventListener('DOMContentLoaded',ensureModal);}
})();